export const InsideProps = [
    {
        code: 'IX0A',
        name: 'insideProps_name_IX0A',
        desc: 'insideProps_desc_IX0A',
        complement: [],
        size: 1,
        lockerSize:['TAMANY3','TAMANY4','TAMANY5','TAMANY6','TAMANY7']
    },
    {
        code: 'IX0B',
        name: 'insideProps_name_IX0B',
        desc: 'insideProps_desc_IX0B',
        complement: [],
        size: 2,
        lockerSize:['TAMANY3','TAMANY4','TAMANY5','TAMANY6','TAMANY7']
    },
    {
        code: 'IX0C',
        name: 'insideProps_name_IX0C',
        desc: 'insideProps_desc_IX0C',
        size: 2,
        lockerSize:['TAMANY3','TAMANY4','TAMANY5','TAMANY6','TAMANY7']
    },
    {
        code: 'IX0D',
        name: 'insideProps_name_IX0D',
        desc: 'insideProps_desc_IX0D',
        size: 2,
        lockerSize:['TAMANY3','TAMANY4','TAMANY5','TAMANY6','TAMANY7']
    },
    {
        code: 'IX0E',
        name: 'insideProps_name_IX0E',
        desc: 'insideProps_desc_IX0E',
        size: 1,
        lockerSize:['TAMANY3','TAMANY4','TAMANY5','TAMANY6','TAMANY7']
    },
    {
        code: 'IX02A',
        name: 'insideProps_name_IX0A',
        desc: 'insideProps_desc_IX0A',
        complement: [],
        size: 1,
        lockerSize:['TAMANY2']
    },
    {
        code: 'IX02B',
        name: 'insideProps_name_IX0B',
        desc: 'insideProps_desc_IX0B',
        size: 2,
        lockerSize:['TAMANY2']
    },
    {
        code: 'IX02C',
        name: 'insideProps_name_IX0C',
        desc: 'insideProps_desc_IX0C',
        size: 2,
        lockerSize:['TAMANY2']
    },
    {
        code: 'IX02E',
        name: 'insideProps_name_IX0E',
        desc: 'insideProps_desc_IX0E',
        size: 1,
        lockerSize:['TAMANY2']
    }
]
